import BaseService from "./BaseService"
import BaseFilter from './BaseFilter';

export class LoginHistoryService extends BaseService{
	constructor() {
		super('/LoginHistory');
	}

	public getAllByFilter(filter: LoginHistoryFilter) {
		return super.getAllByFilterBase(filter);
	}
}
	
export class LoginHistoryFilter extends BaseFilter {
	constructor(idUser?: number | null, idRight?: number | null, isLast?: boolean | null, idTenant?: number | null, isSuperUser?: boolean | null,) {
		super();
		this._idUser = idUser;
		this._idRight = idRight;
		this._isLast = isLast;
		this._idTenant = idTenant;
		this._isSuperUser = isSuperUser;
	}

	private _idUser?: number | null;
	private _idRight?: number | null;
	private _isLast?: boolean | null;
	private _idTenant?: number | null;
	private _isSuperUser?: boolean | null;

	public getAllParams(): {} {
		let data = Object.assign({},
			(this._idUser != null ? { IdUser: this._idUser } : {}),
			(this._idRight != null ? { IdRight: this._idRight } : {}),
			(this._isLast != null ? { IsLast: this._isLast } : {}),
			(this._idTenant != null ? { IdTenant: this._idTenant } : {}),
			(this._isSuperUser != null ? { IsSuperUser: this._isSuperUser } : {})

		);

		return data;
	};
}